import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireDatabase, AngularFireList  } from 'angularfire2/database';
import { Post } from '../../class/post';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent {

  rForm: FormGroup;
  post:any;                     // A property for our submitted form
  description:string = '';
  name:string = '';
  titleAlert:string = 'This field is required';

  posts: Post[];
  postsRef: AngularFireList<any>;

  constructor(
    private fb: FormBuilder,
    private db: AngularFireDatabase
  ) { 
    this.postsRef = this.db.list('posts');
    this.rForm = fb.group({
      'name' : [null, Validators.required],
      'description' : [null, Validators.compose([Validators.required, Validators.minLength(30), Validators.maxLength(500)])],
    });
  }

  addPost(post) {
    this.description = post.description;
    this.name = post.name;
    this.postsRef.push(new Post({name: post.name, description: post.description}))
  }
}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/form/contact/contact.component.ts